import React from 'react';
import { Button, Stack } from '@mui/material';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { TravelType, isOneWayTrip, isRoundTrip } from '../../../domain/travels';

interface Props {
  travelType: TravelType;
  onTravelTypeChange: (type: TravelType) => void;
}

export const TravelTypeSelect = ({ travelType, onTravelTypeChange }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack
      gap="6px"
      width="fit-content"
      border="1px solid rgba(0, 0, 0, 0.12)"
      padding="4px"
      direction="row"
      borderRadius="8px"
    >
      <Button
        sx={{ border: 'none !important', boxShadow: 'none' }}
        size="large"
        variant={isOneWayTrip(travelType) ? 'contained' : 'outlined'}
        onClick={() => onTravelTypeChange(TravelType.OneWay)}
      >
        {t('trip_types.one_way')}
      </Button>
      <Button
        sx={{ border: 'none !important', boxShadow: 'none' }}
        size="large"
        variant={isRoundTrip(travelType) ? 'contained' : 'outlined'}
        onClick={() => onTravelTypeChange(TravelType.RoundTrip)}
      >
        {t('trip_types.round_trip')}
      </Button>
    </Stack>
  );
};
